export default __webpack_public_path__ + "static/media/66839984f643ea2b.efb3200ba4cee8a3cc73456805130e24.svg";